import { userInfo } from '@store';
import { useRecoilValue } from 'recoil';

export const useSectorMark = () => {
  const getUserInfo = useRecoilValue(userInfo);

  if (!getUserInfo) {
    return '加载中...'; // 或者直接返回空字符串 ''
  }

  // return getUserInfo?.roleKeys === ROLE_KEYS_MAP.admin
  //   ? 'Sales team'
  //   : 'Sector';
  return 'Sales team';
};
